import {ProjectTypes} from './project-types.enum';

export enum AppointmentProjectTypes {
  GEO_ADVANCED = ProjectTypes.GEO_ADVANCED,
  GEO_ADVANCED_WIDGET = ProjectTypes.GEO_ADVANCED_WIDGET
}
